import styled from 'styled-components';

export const RespostaSolicitacaoWrapper = styled.div`
  border: 1px solid #b1b3b3;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  color: #4d4d4d;
  font-size: 400;
  font-size: 16px;
  margin-bottom: 40px;
  white-space: pre-wrap;
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 20px;
  color: ${(props) => props?.tema?.primaryColor};
  line-height: 30px;
  margin-bottom: 8px;
`;
